import { render, staticRenderFns } from "./DeleteRecordDialog.vue?vue&type=template&id=1ae281ea&"
import script from "./DeleteRecordDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports